import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getBoxes } from 'services/funds'

export default function useGetFunds() {
    const [moneyPools, setMoneyPools] = useState<Array<MoneyPool> | undefined>()
    const [cashBoxes, setCashBoxes] = useState<Array<ICashBoxes> | undefined>()
    const { data, isLoading, refetch } = useQuery(['get-boxes'], getBoxes)
    useEffect(() => {
        if (data) {
            setMoneyPools(data?.moneypools)
            setCashBoxes(data?.cashboxes)
        }
    }, [data])
    return { moneyPools, cashBoxes, isLoading }
}
